module.exports = __webpack_public_path__ + "img/Penny-Hat-01.1ff5e7d7.jpg";